var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50.000000pt",
    height: "50.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#880C55",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 460 c-18 -18 -20 -33 -20 -185 0 -152 2 -167 20 -185 19 -19 33 -20 250 -20 l230 0 0 180 0 180 -186 0 c-186 0 -187 0 -210 25 -28 30 -57 32 -84 5z m68 -12 c8 -8 12 -53 12 -138 l0 -125 -40 0 -40 0 0 125 c0 128 6 150 40 150 9 0 21 -5 28 -12z m332 -134 c0 -32 -2 -35 -15 -24 -13 11 -21 8 -48 -18 l-33 -32 -27 27 -26 27 -41 -33 c-25 -20 -40 -27 -40 -18 0 7 18 28 41 46 l41 33 27 -26 27 -26 24 25 c19 20 21 27 10 40 -11 13 -8 15 24 15 35 0 36 -1 36 -36z m0 -144 c0 -6 -48 -10 -125 -10 -77 0 -125 4 -125 10 0 6 48 10 125 10 77 0 125 -4 125 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutProject);
export default __webpack_public_path__ + "static/media/About_Project.0721404c69cd4dff81d5e5503ce5cbc3.svg";
export { ForwardRef as ReactComponent };